import React from 'react';
import {motion} from 'framer-motion';

const PersonalNoteSection = () => {
  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto px-6 lg:px-8">
        <div className="max-w-6xl mx-auto">
          {/* Full width heading */}
          <motion.div 
            initial={{opacity: 0, y: 30}} 
            whileInView={{opacity: 1, y: 0}} 
            transition={{duration: 0.8}} 
            viewport={{once: true}}
            className="mb-12"
          >
            <h2 className="text-4xl lg:text-5xl font-bold text-gray-900">
              Warum du bei mir richtig bist
            </h2>
          </motion.div>
          
          <div className="grid lg:grid-cols-2 gap-16 items-center">
            {/* Text Column (now first) */}
            <motion.div 
              initial={{opacity: 0, x: -50}} 
              whileInView={{opacity: 1, x: 0}} 
              transition={{duration: 0.8}} 
              viewport={{once: true}}
              className="space-y-6"
            >
              <div className="text-lg text-gray-600 leading-relaxed space-y-5">
                <p>
                  Viele meiner Kund:innen starten mit dem Gefühl, nicht genau zu wissen, wo sie anfangen sollen. Vielleicht ist da Unsicherheit, vielleicht auch das Gefühl, etwas falsch machen zu können.
                </p>
                <p>
                  Das ist völlig normal.
                </p>
                <p>
                  Wir schauen uns deine Situation gemeinsam an – in Ruhe. Ich erkläre dir verständlich, wie du deine Buchhaltung so gestaltest, dass sie für dich funktioniert und sich stimmig anfühlt.
                </p>
                <p>
                  Ohne Fachsprache. <br />
                  Ohne Bewertung. <br />
                  In deinem Tempo.
                </p>
                <p>
                  Mein Ziel ist, dass du nach kurzer Zeit selbstständig damit arbeiten kannst. <br />
                  Sicher. Klar. Und mit einem guten Gefühl.
                </p>
              </div>
              <div className="mt-8">
                <motion.a 
                  href="https://nextcloud.managershop.com/index.php/apps/appointments/pub/Gb05r41McyYVyGQE/form" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  whileHover={{scale: 1.05}} 
                  whileTap={{scale: 0.95}}
                  className="bg-[#E30613] hover:bg-[#C10511] text-white px-8 py-4 rounded-lg font-semibold text-lg transition-all duration-300 inline-block shadow-lg"
                >
                  Gespräch vereinbaren
                </motion.a>
                <p className="text-sm text-gray-500 mt-4">
                  Du entscheidest danach in Ruhe, ob und wie du weitermachen möchtest.
                </p>
              </div>
            </motion.div>
            
            {/* Image Column (now second) */}
            <motion.div 
              initial={{opacity: 0, x: 50}} 
              whileInView={{opacity: 1, x: 0}} 
              transition={{duration: 0.8}} 
              viewport={{once: true}}
              className="flex justify-center"
            >
              <div className="bg-[#F3F1EE] p-4 rounded-2xl">
                <img 
                  src="https://github.com/mike3011/Bilder/blob/main/Bild_Nadine_Rau_freigestellt.png?raw=true" 
                  alt="Nadine Rau" 
                  className="w-full max-w-sm h-auto object-cover rounded-xl"
                />
              </div>
            </motion.div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PersonalNoteSection;